// @flow

export const localStorage = window.localStorage;
export const sessionStorage = window.sessionStorage;
export const translationStorage = {};



// WEBPACK FOOTER //
// ./src/utils/storage.js